<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <h2 class="title">Jobs</h2>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right>
    <div style="margin-bottom: 0.5rem; margin-right: 0.5rem">
      <input
        type="radio"
        name="dateOption"
        id="CREATED"
        value="CREATED"
        [formControl]="dateType"
        [checked]="true"
      />
      <label for="CREATED" style="margin-right: 0.5rem">Actual Date</label>

      <input
        type="radio"
        name="dateOption"
        id="RECON"
        value="RECON"
        [formControl]="dateType"
      />
      <label for="RECON">Recon Date</label>
    </div>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <div style="min-width: 210px; width: 210px">
      <label class="small">Date</label>
      <nf-daterange
        id="dateRange"
        [(ngModel)]="dateRange"
        (ngModelChange)="onDateRangeChange($event, true)"
        [beginDateRequired]="false"
        [endDateRequired]="false"
      ></nf-daterange>
    </div>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <div class="job-id-filter">
      <label class="small">Job Id</label>
      <input
        type="text"
        id="search-job-ids"
        class="form-control"
        [formControl]="searchJobIdsForm"
        placeholder="Search by Job Ids"
      />
    </div>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <input
      type="text"
      id="search-account-ids"
      class="form-control"
      [formControl]="searchAccountIdsForm"
      (keyup.enter)="onAccountFilterChange()"
      placeholder="Search by Account Ids"
    />
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="secondary"
      icon="magnify"
      class="compact-search"
      placement="bottom-right"
      autoClose="outside"
      style="margin-right: 8px"
      (click)="onAccountFilterChange()"
    >
      Search
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>

  <nf-grid-wrapper-content *ngIf="invalidPermission">
    <hs-panel-card
      class="d-flex flex-column w-100 h-100"
      header="Permission missing"
    >
      <p>
        You don't have permission to view one or more of the requested accounts
      </p>
    </hs-panel-card>
  </nf-grid-wrapper-content>
  <nf-grid-wrapper-content *ngIf="!invalidPermission">
    <nf-table-layout
      class="jobs-table-layout"
      [hideTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [autoResizeGrid]="false"
      [data]="data"
      hideSearch
      hideClearAll
      *nfLoader="isLoading"
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
